import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
    className?: string,
};

const EventFormContainer: React.FC<Props> = ({
    children,
    className = '',
}) => {
    const theme = useTheme();

    const style = css`
        width: 622px;
        display: flex;
        flex-direction: column;
        padding-bottom: 22px;

        ${theme.breakpoints.only('lg')} {
            width: 580px;
            padding-right: 14px;
        }

        ${theme.breakpoints.only('md')} {
            width: 677px;
        }

        ${theme.breakpoints.only('sm')} {
            padding: 0 23px;
        }
    `;

    return (
        <div css={style} className={className}>
            {children}
        </div>
    );
}

export default EventFormContainer;
